import React, { useRef } from 'react';
import {
  Box,
  Typography,
  Button,
  alpha
} from '@mui/material';
import {
  Folder,
  Edit,
  CloudDone
} from '@mui/icons-material';
import GooglePicker from './GooglePicker';

const DestinationFolderDisplay = ({ 
  selectedFolder, 
  onSelectFolder, 
  isConnected 
}) => {
  const pickerRef = useRef(null);

  const handleOpenPicker = () => {
    if (pickerRef.current) {
      pickerRef.current.openPicker();
    }
  };

  if (!isConnected) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      {/* GooglePicker component is always mounted but hidden */}
      <GooglePicker ref={pickerRef} onFolderSelected={onSelectFolder} />
      
      {!selectedFolder ? (
        <Box sx={{ 
          p: 3,
          border: '1px solid',
          borderColor: alpha('#e0e0e0', 0.3),
          borderRadius: 2,
          backgroundColor: alpha('#fafafa', 0.5),
          backdropFilter: 'blur(10px)'
        }}>
          <Typography variant="h6" sx={{ 
            fontWeight: 500, 
            color: 'text.primary',
            mb: 1
          }}>
            Destination Folder
          </Typography>
          <Typography variant="body2" sx={{ 
            color: 'text.secondary',
            fontSize: '0.875rem',
            mb: 2
          }}>
            Choose where to save your scraped content
          </Typography>
          
          <Button
            variant="contained"
            startIcon={<Folder />}
            onClick={handleOpenPicker}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              px: 3,
              py: 1,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: alpha('#1976d2', 0.2) + ' 0px 4px 12px',
              }
            }}
          >
            Choose Folder
          </Button>
        </Box>
      ) : (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          p: 3,
          border: '1px solid',
          borderColor: alpha('#4caf50', 0.2),
          borderRadius: 2,
          backgroundColor: alpha('#f1f8e9', 0.3),
          backdropFilter: 'blur(10px)'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: alpha('#4caf50', 0.1),
              color: '#4caf50'
            }}>
              <CloudDone />
            </Box>
            <Box>
              <Typography variant="h6" sx={{ 
                fontWeight: 500, 
                color: 'text.primary',
                mb: 0.5
              }}>
                {selectedFolder.name}
              </Typography>
              <Typography variant="body2" sx={{ 
                color: 'text.secondary',
                fontSize: '0.875rem'
              }}>
                Ready to save scraped content
              </Typography>
            </Box>
          </Box>
          
          <Button
            variant="outlined"
            startIcon={<Edit />}
            onClick={handleOpenPicker}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              px: 2,
              py: 1,
              borderColor: alpha('#4caf50', 0.3),
              color: '#4caf50',
              '&:hover': {
                borderColor: '#4caf50',
                backgroundColor: alpha('#4caf50', 0.05),
              }
            }}
          >
            Change
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default DestinationFolderDisplay;
